import axios from 'axios';

//  Get the current station configuration ListingStatus
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getListingStatus = params => {
    return axios.get('/api-site/snapshot/listing-status', { params });
};
//  according to listingStatus Get property data 
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getSnapshotListing = params => {
    return axios.get(`/api-site/snapshot/listings`, { params });
};
// market report  interface 
// https://wh.chimewiki.me/pages/viewpage.action?pageId=40509708
export const getMarketReport = params => {
    // params = Object.keys(params).reduce((prev, cur) => {
    //     const value = params[cur];
    //     if (value === null) return prev;
    //     prev += `&${encodeURIComponent(cur)}=${encodeURIComponent(value)}`;
    //     return prev;
    // }, '');
    return axios.get(`/api-site/snapshot/market-report`, { params });
};
